import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'HKLSC Registration';
    isAdmin = false;
    currentYear = new Date().getFullYear();

    constructor(private router: Router, public apiService: ApiService) { }
    project = 'hklsc_pthyxs';
    ngOnInit() {
        this.project = this.apiService.project;
        this.router.events.subscribe(() => {
            this.isAdmin = this.router.url === '/admin';
        });
    }
}
